<template>
  <path
    d="M3 17.0002H21C21.55 17.0002 22 17.4502 22 18.0002C22 18.5502 21.55 19.0002 21 19.0002H3C2.45 19.0002 2 18.5502 2 18.0002C2 17.4502 2.45 17.0002 3 17.0002ZM13.84 7.79024C13.94 7.55024 14 7.28024 14 7.00024C14 5.90024 13.1 5.00024 12 5.00024C10.9 5.00024 10 5.90024 10 7.00024C10 7.28024 10.06 7.55024 10.16 7.79024C6.25 8.60024 3.27 11.9302 3 16.0002H21C20.73 11.9302 17.75 8.60024 13.84 7.79024Z"
  />
</template>
